"use client";

import { TableHead, TableRow } from "@/shadcn-components/ui/table";
import { Button } from "@/shadcn-components/ui/button";
import { Input } from "@/shadcn-components/ui/input";
import {
  historyTh,
  HISTORY_POSITION_COL_WIDTHS,
} from "./historyDesktopTableLayout";
import type { HistorySortFilterTableHeaderProps } from "./historySortFilterHeaderTypes";

const W = HISTORY_POSITION_COL_WIDTHS;

export function HistoryPositionsTableHeader({
  sortColumn,
  sortDirection,
  filters,
  showFilterInputs,
  onSort,
  onFilterChange,
  renderSortIcon,
  renderFilterDropdown,
}: HistorySortFilterTableHeaderProps) {
  void sortColumn;
  void sortDirection;

  const sortButton = (column: string, label: string) => (
    <Button
      variant="ghost"
      size="sm"
      className="h-5 gap-0 px-0.5 text-[11px] font-medium"
      onClick={() => onSort(column)}
    >
      {label}
      {renderSortIcon(column)}
    </Button>
  );

  const headerCell = (
    column: string,
    label: string,
    placeholder: string,
    widthClass: string,
    alignRight = false
  ) => (
    <TableHead
      className={`${historyTh} ${widthClass}${alignRight ? " text-right" : ""}`}
    >
      <div className={`flex items-center${alignRight ? " justify-end" : ""}`}>
        {sortButton(column, label)}
        {!showFilterInputs && renderFilterDropdown(column, placeholder)}
      </div>
    </TableHead>
  );

  const filterCell = (
    column: string,
    placeholder: string,
    widthClass: string
  ) => (
    <TableHead className={`h-7 px-1.5 py-0.5 ${widthClass}`}>
      <Input
        placeholder={placeholder}
        value={filters[column] || ""}
        onChange={(e) => onFilterChange(column, e.target.value)}
        className="h-5 px-1.5 text-[11px]"
      />
    </TableHead>
  );

  return (
    <>
      <TableRow>
        {headerCell("openTime", "Open time", "Filter open time...", W.openTime)}
        {headerCell("symbol", "Symbol", "Filter symbols...", W.symbol)}
        {headerCell("ticket", "Position", "Filter position id...", W.ticket)}
        {headerCell("type", "Type", "Filter type...", W.type)}
        {headerCell("lots", "Lots", "Filter lots...", W.lots, true)}
        {headerCell("openPrice", "Open price", "Filter open price...", W.openPrice, true)}
        {headerCell("tp", "TP", "Filter TP...", W.tp, true)}
        {headerCell("sl", "SL", "Filter SL...", W.sl, true)}
        {headerCell("closeTime", "Close time", "Filter close time...", W.closeTime)}
        {headerCell("closePrice", "Close price", "Filter close price...", W.closePrice, true)}
        {headerCell("commission", "Commission", "Filter commission...", W.commission, true)}
        {headerCell("swap", "Swap", "Filter swap...", W.swap, true)}
        {headerCell("pnl", "P&L", "Filter P&L...", W.pnl, true)}
        {headerCell("change", "Change %", "Filter change...", W.change, true)}
      </TableRow>

      {showFilterInputs && (
        <TableRow className="border-b bg-background">
          {filterCell("openTime", "Filter open time...", W.openTime)}
          {filterCell("symbol", "Filter symbols...", W.symbol)}
          {filterCell("ticket", "Filter position id...", W.ticket)}
          {filterCell("type", "Filter type...", W.type)}
          {filterCell("lots", "Filter lots...", W.lots)}
          {filterCell("openPrice", "Filter open price...", W.openPrice)}
          {filterCell("tp", "Filter TP...", W.tp)}
          {filterCell("sl", "Filter SL...", W.sl)}
          {filterCell("closeTime", "Filter close time...", W.closeTime)}
          {filterCell("closePrice", "Filter close price...", W.closePrice)}
          {filterCell("commission", "Filter commission...", W.commission)}
          {filterCell("swap", "Filter swap...", W.swap)}
          {filterCell("pnl", "Filter P&L...", W.pnl)}
          {filterCell("change", "Filter change...", W.change)}
        </TableRow>
      )}
    </>
  );
}
